export default {
  SUBSCRIPTIONS_FETCHED: 'SUBSCRIPTIONS_FETCHED',
  SUBSCRIPTIONS_LOAD: 'SUBSCRIPTION_LOAD',
  SUBSCRIPTIONS_REWARD_LOAD: 'SUBSCRIPTION_REWARD_LOAD',
  SUBSCRIPTIONS_REWARD_MODAL: 'SUBSCRIPTION_REWARD_MODAL',
  SUBSCRIPTIONS_CANCEL_MODAL: 'SUBSCRIPTION_CANCEL_MODAL',
};
